
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiting_info/archives/[id]",
      function () {
        return require("private-next-pages/recruiting_info/archives/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiting_info/archives/[id]"])
      });
    }
  